import type { IconSvgObject } from './types';

const Progress03Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 5.5001C12 4.94781 12.4497 4.49323 12.9971 4.56664C14.6181 4.78405 16.1339 5.52741 17.3033 6.6968C18.7098 8.10332 19.5 10.011 19.5 12.0001C19.5 13.9892 18.7098 15.8969 17.3033 17.3034C16.1339 18.4728 14.6181 19.2161 12.9971 19.4336C12.4497 19.507 12 19.0524 12 18.5001L12 5.5001Z", fill: "currentColor", key: "1" }]
];

export default Progress03Icon;
